var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMakeTelevisit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 124,
    viewBox: "0 0 123 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 25,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#82D1EE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_25941_71392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5625 57.6133L55.457 56.2812C57.9492 54.5625 59.625 51.6836 59.625 48.375C59.625 43.0898 55.2852 38.75 50 38.75C44.6719 38.75 40.375 43.0898 40.375 48.375C40.375 51.6836 42.0078 54.5625 44.5 56.2812L42.3945 57.6133C41.9648 57.8711 41.75 58.3008 41.75 58.7734V59.418C41.75 60.1484 42.3516 60.75 43.125 60.75H56.875C57.6055 60.75 58.25 60.1484 58.25 59.375V58.7734C58.25 58.3008 57.9922 57.8711 57.5625 57.6133ZM50 55.25C46.1758 55.25 43.082 52.1992 43.082 48.418C43.082 44.6797 46.1758 41.543 49.957 41.543C53.6953 41.543 56.832 44.6367 56.832 48.418C56.832 52.2422 53.7812 55.25 50 55.25ZM50 42.875C46.9492 42.875 44.457 45.3672 44.457 48.375C44.457 51.4258 46.9492 53.875 49.957 53.875C53.0078 53.875 55.457 51.4258 55.457 48.375C55.457 45.3672 53.0078 42.875 50 42.875ZM49.957 46.3125C48.8398 46.3125 47.9375 47.2578 47.8945 48.375C47.8945 48.7617 47.5938 49.0625 47.207 49.0625C46.8633 49.0625 46.5195 48.7617 46.5195 48.375C46.5625 46.4844 48.0664 44.9375 49.957 44.9375C50.3438 44.9375 50.6445 45.2812 50.6445 45.625C50.6445 46.0117 50.3438 46.3125 49.957 46.3125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_25941_71392",
    x: -22.125,
    y: -23.75,
    width: 144.25,
    height: 147,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.329412 0 0 0 0 0.529412 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25941_71392"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25941_71392",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeTelevisit);
export default __webpack_public_path__ + "static/media/make-televisit.de6dfa20.svg";
export { ForwardRef as ReactComponent };